import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  Paper,
  CircularProgress,
  InputAdornment,
  // IconButton,
  // Dialog,
  // // DialogActions,
  // DialogContent,
  // DialogTitle,
  //   Checkbox,
  //   Button,
} from "@mui/material";
import {
  //  CheckIcon,
  FontFamily,
  // PendingIcon,
  SearchIcon,
} from "assets";
import Colors from "assets/Style/Colors";
// import { PrimaryButton } from "components/Buttons";
import SelectField from "components/Select";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
// import {
//   Visibility as VisibilityIcon,
//   // Close as CloseIcon
// } from "@mui/icons-material";
import DropdownMenu from "components/DropDown";
import Pagination from "components/Pagination";
// import { ErrorToaster } from "components/Toaster";
import InputField from "components/Input";
import { Debounce } from "utils";
import SupplierServices from "services/Supplier";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import PaymentStatus from "components/PaymentStatus";
import moment from "moment";
// import VendorServices from "services/Vendor";
// import SystemServices from "services/System";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
import { formatPermissionData } from "utils";
import { addPermission } from "redux/slices/navigationDataSlice";
import { useDispatch } from "react-redux";
// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function PaidBillsList() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const [loader, setLoader] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [bills, setBills] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const classes = useStyles();
  const [billId, setBillId] = useState();
  const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [permissions, setPermissions] = useState({});
    const dispatch = useDispatch();
  const [confirmationApprovalDialog, setConfirmationApprovalDialog] =
    useState(false);
  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };
  const navigate = useNavigate();

  const tableHead = [
    "Bill no.",
    "Supplier Name",
    "Paid Date",
    "Remarks",
    "Due Amount (د.إ)",
    "Paid Amount (د.إ)",
    "Balance Amount (د.إ)",
    "Paid By",
    "Paid Method",
    "Pmt. Ref. #",
    "Pmt. Ext. Ref. #",
    "Past Due Days",
    "Pmt Status",
    "Action",
  ];

  const sanitizeFilters = (obj) => {
    const next = { ...(obj || {}) };
    Object.keys(next).forEach((key) => {
      const value = next[key];
      if (value === undefined || value === null || value === "") {
        delete next[key];
      }
    });
    return next;
  };

  const getPaymentStatusKey = (status) =>
    status?.toString().trim().toLowerCase() || "";

  const applyPaymentStatusFilter = (rows, paymentStatus) => {
    if (!paymentStatus || paymentStatus === "all") {
      return rows.filter((bill) => {
        const status = getPaymentStatusKey(bill?.pmt_status);
        return status === "paid" || status === "partial";
      });
    }

    return rows.filter(
      (bill) => getPaymentStatusKey(bill?.pmt_status) === paymentStatus,
    );
  };

  const getBill = async (page, limit, filter) => {
    setLoader(true);

    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = sanitizeFilters({ ...filters, ...filter });
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
      let params = {
        page: Page,
        limit: Limit,
        approved: true,
      };
      const { paymentStatus, ...apiFilters } = Filter;
      params = { ...params, ...apiFilters };

      const data = await SupplierServices.getBill(params);
      const allBills = data?.data?.bills?.rows ?? [];
      const filteredBills = applyPaymentStatusFilter(allBills, paymentStatus);
      setBills(filteredBills);
      const serverCount = data?.data?.bills?.count;
      const hasExplicitServerStatusFilter = Object.prototype.hasOwnProperty.call(
        apiFilters,
        "status",
      );
      setTotalCount(
        paymentStatus && paymentStatus !== "all"
          ? filteredBills.length
          : !hasExplicitServerStatusFilter
            ? filteredBills.length
            : serverCount > 0
            ? serverCount
            : allBills.length,
      );
      setPermissions(formatPermissionData(data?.data?.permissions))
      data?.data?.permissions?.forEach((e) => {
  if (e?.route && e?.identifier && e?.permitted) {
    dispatch(addPermission(e?.route));
  }
});
      
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };
  const [billRefNo, setBillRefNo] = useState(null);
  const deleteBill = async () => {
    if (!billId) {
      ErrorToaster("Invalid Bill ID");
      return;
    }
    try {
      const params = { ref_no: billRefNo };
      const { message } = await SupplierServices.deletePaidBill(params);
      SuccessToaster(message);
      setConfirmationDialog(false);
      setBillId(null);
      getBill();
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleFilter = (data) => {
    Debounce(() => getBill(1, "", data));
  };

  useEffect(() => {
    getBill();
  }, []);

  const calculateTotalAmount = (billAccounts) => {
    return billAccounts.reduce(
      (total, account) => total + (parseFloat(account?.total_amount) || 0),
      0,
    );
  };

  const calculatePaidAmount = (billAccounts) => {
    return billAccounts.reduce(
      (total, account) => total + (parseFloat(account?.paid_amount) || 0),
      0,
    );
  };

  const calculateBalance = (billAccounts) => {
    const total = billAccounts.reduce(
      (sum, account) => sum + (parseFloat(account?.total_amount) || 0),
      0,
    );
    const paid = calculatePaidAmount(billAccounts);
    return total - paid;
  };

  const getFormattedDate = (value) => {
    if (!value) {
      return "-";
    }

    const parsedDate = moment(value, ["YYYY-MM-DD", moment.ISO_8601], true);
    return parsedDate.isValid() ? parsedDate.format("DD-MM-YYYY") : "-";
  };

  const getLatestPaidDate = (billAccounts) => {
    const dates = billAccounts
      .map((a) => a?.pay_bill_date)
      .filter(Boolean)
      .sort((a, b) => moment(b, ["YYYY-MM-DD", moment.ISO_8601], true).valueOf() - moment(a, ["YYYY-MM-DD", moment.ISO_8601], true).valueOf());
    return dates[0] ?? null;
  };

  const calculatePastDueDays = (billDate, billAccounts) => {
    const latestPaidDate = getLatestPaidDate(billAccounts || []);

    if (!billDate || !latestPaidDate) {
      return "-";
    }

    const bookedDate = moment(billDate, ["YYYY-MM-DD", moment.ISO_8601], true);
    const paidDate = moment(latestPaidDate, ["YYYY-MM-DD", moment.ISO_8601], true);

    if (!bookedDate.isValid() || !paidDate.isValid()) {
      return "-";
    }

    const differenceInDays = Math.floor(
      paidDate.startOf("day").diff(bookedDate.startOf("day"), "days", true),
    );

    return differenceInDays >= 0 ? differenceInDays : 0;
  };

  const getPaidMethod = (billAccounts) => {
    const methods = [...new Set(
      billAccounts.map((a) => a?.payment_method).filter(Boolean)
    )];
    return methods.length > 0
      ? methods.map((m) => (m === "vault" ? "Wallet" : m)).join(", ")
      : "-";
  };

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  return (
    <Box sx={{ m: 4, mb: 8 }}>
      <ConfirmationDialog
        open={confirmationDialog}
        onClose={() => setConfirmationDialog(false)}
        message={"Are you sure you want to delete this?"}
        action={() => deleteBill()}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
          mt: 4,
        }}
      >
        <Typography
          sx={{
            color: "#094526",
            fontFamily: "Helvetica",
            fontSize: "32px",
            fontStyle: "Bold",
            fontWeight: 700,
          }}
        >
          Paid Bills List
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* <Box >
            <PrimaryButton title={"Add Supplier"} onClick={() => window.open("/supplier-onboarding")} />
          </Box> */}
        </Box>
      </Box>

      {/* Form Section */}
      <Box
      // sx={{
      //   boxShadow: "0px 4px 4px 0px #00000040",
      //   p: 3,
      //   borderRadius: "12px",
      // }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <InputField
              size={"small"}
              inputStyle={{ backgroundColor: "#f5f5f5" }}
              label={"Search"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={"Search"}
              register={register("search", {
                onChange: (e) => handleFilter({ search: e.target.value }),
              })}
            />
          </Grid>

          {/* <Grid item xs={12} sm={3}>
            <SelectField
              label={"Supplier"}
              options={vendors}
              selected={selectedVendor}
              onSelect={(value) => {
                setSelectedVendor(value);
              }}
              register={register("vendor", {
                required: "Please select Vendor.",
              })}
            />
          </Grid> */}

          <Grid item xs={12} sm={3}>
            <SelectField
              label={"Payment Status"}
              options={[
                { id: "all", name: "All" },
                { id: "paid", name: "Paid" },
             
                { id: "unpaid", name: "Un-Paid" },
              ]}
              selected={selectedSupplier}
              onSelect={(value) => {
                setSelectedSupplier(value);

                if (!value?.id || value?.id === "all") {
                  handleFilter({ status: null, paymentStatus: null });
                  return;
                }

                if (value?.id === "paid") {
                  handleFilter({ status: "true", paymentStatus: null });
                  return;
                }

                if (value?.id === "partial") {
                  handleFilter({ status: null, paymentStatus: "partial" });
                  return;
                }

                if (value?.id === "unpaid") {
                  handleFilter({ status: "false", paymentStatus: null });
                  return;
                }
              }}
              register={register("paymentStatus")}
            />
          </Grid>
        </Grid>
      </Box>

      {/* ========== Table ========== */}
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0px 8px 18px 0px #9B9B9B1A",
          borderRadius: 2,
          maxHeight: "calc(100vh - 330px)",
          mt: 5,
        }}
        className="table-box"
      >
        <Table stickyHeader sx={{ minWidth: 500 }}>
          <TableHead>
            <TableRow>
              {tableHead.map((item, index) => (
                <Cell className="pdf-table" key={index}>
                  {item}
                </Cell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!loader ? (
              bills?.length > 0 ? (
                <Fragment>
                  {bills.map((item, index) => {
                    // const isSelected = selectedRows?.some(
                    //   (selected) => selected?.id === item?.id
                    // );

                    return (
                      <Row
                        key={index}
                        sx={{ bgcolor: index % 2 !== 0 && "#EEFBEE" }}
                      >
                        <Cell className="pdf-table">
                          {item?.bill_no ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.suppliers?.company_name ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {getLatestPaidDate(item?.bill_accounts)
                            ? getFormattedDate(getLatestPaidDate(item?.bill_accounts))
                            : "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.notes ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {calculateTotalAmount(item?.bill_accounts).toFixed(2)}
                        </Cell>
                        <Cell className="pdf-table">
                          {calculatePaidAmount(item?.bill_accounts).toFixed(2)}
                        </Cell>
                        <Cell className="pdf-table">
                          {calculateBalance(item?.bill_accounts).toFixed(2)}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.created_by ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {getPaidMethod(item?.bill_accounts)}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.ref_no ? `REF-${item.ref_no}` : "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item?.external_ref_no ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {calculatePastDueDays(
                            item?.bill_date,
                            item?.bill_accounts,
                          )}
                        </Cell>
                        <Cell className="pdf-table">
                          <PaymentStatus status={item?.pmt_status} />
                        </Cell>
                        <Cell className="pdf-table">
                          <DropdownMenu
                            item={item}
                            permissions={permissions}
                            navigate={navigate}
                            isOpen={activeMenu === item?.id}
                            onToggle={(isOpen) =>
                              handleMenuToggle(item?.id, isOpen)
                            }
                            id={item?.id}
                            paidBillsView={() => {
                              window.open(
                                `/supplier-bill-receipt/${item?.id}`,
                              );
                            }}
                            paidBillsDelete={() => {
                              setConfirmationDialog(true);
                              setBillId(item?.id);
                              setBillRefNo(item?.ref_no);
                            }}
                          />
                        </Cell>
                      </Row>
                    );
                  })}
                </Fragment>
              ) : (
                <Row>
                  <Cell colSpan={14} align="center" sx={{ fontWeight: 600 }}>
                    No Data Found
                  </Cell>
                </Row>
              )
            ) : (
              <TableRow>
                <TableCell colSpan={14} align="center" sx={{ border: 0, py: 4 }}>
                  <CircularProgress size={40} sx={{ color: Colors.primary }} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {bills?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          pageSize={pageLimit}
          onPageSizeChange={(size) => getBill(1, parseInt(size.target.value))}
          tableCount={bills?.length}
          totalCount={totalCount}
          onPageChange={(page) => getBill(page, pageLimit)}
        />
      )}
    </Box>
  );
}

export default PaidBillsList;
